import { isFunction } from "lodash";
import { MdKeyboardBackspace, MdInfo } from "react-icons/md";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  nextText = "Continuer",
  backText = "Retour",
  nextProps = {},
  backProps = {},
  infoText,
}) => {
  return (
    <div className="miltis__actions">
      {isFunction(onBack) && (
        <div className="miltis__actions--back" onClick={onBack} {...backProps}>
          <MdKeyboardBackspace />
          <span>{backText}</span>
        </div>
      )}
      {isFunction(onNext) && (
        <div className="miltis__actions--primary">
          <Button
            block
            type="primary"
            className="miltis__actions--next"
            onClick={onNext}
            {...nextProps}
          >
            {nextText}
          </Button>
          {infoText && (
            <div className="miltis__actions--info">
              <MdInfo size={24} />
              <p dangerouslySetInnerHTML={{ __html: infoText }} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionButtons;
